import keyMirror from "keymirror"

export default keyMirror({
  ///Messagections
  MESSAGE_CREATE:null,

  ///AUTH
  AUTH: null,
  AUTH_LOGOUT:null,
  AUTH_ERROR:null,
  AUTH_NOUSER:null,
  ACCOUNT_UPDATE:null,
  ACCOUNT_CREATED:null,
  UPDATE_CARD:null,
  UPDATE_TOKEN:null,
  PAYMENT_DONE:null,
  ERROR_CARD:null,
  ERROR_PAY:null,

  MEMBER_GET_DETAIL:null,
  MEMBER_GET_PAID_LIST:null,
  SCHEDULE_GET_LIST:null,
  API_ERROR:null
})



// WEBPACK FOOTER //
// ./src/constants/Constants.js